package com.macrofocus.eflux

import web.cssom.px

object EFluxGlobals {
    val docking = Docking.Overlay

    val appBarHeight = 60.px
    val timeSeriesWidth = if(docking == Docking.Drawer) 180.0 else 180.0
}